//services/Feed.js
import axios from "axios";
import config from "../config";
import { getToken } from "../utils/tokenUtils";

const apiurl = config.API_URL;

//get list of interests
export const getInterestsList = async () => {
  const token = getToken();
  try {
    const response = await axios.get(
      `${apiurl}/api/v1/user/new-account-pops/interests`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

// get list of interests 
export const getInterestsAreas = async () => {
  const token = getToken();
  try {
    const response = await axios.get(
      `${apiurl}/api/v1/user/new-account-pops/interests/areas`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

// profile instance
export const updateProfileInstance = async (data) => {
  const token = getToken();
  try {
    const response = await axios.put(
      `${apiurl}/api/v1/user/new-account-pops/profile-instance`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

//get custom interests
export const getCustomInterests = async () => {
  const token = getToken();
  try {
    const response = await axios.get(
      `${apiurl}/api/v1/user/new-account-pops/interests/custom`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

//update user selected interests
export const updateInterests = async (interests) => {
  const token = getToken();
  try {
    const response = await axios.post(
      `${apiurl}/api/v1/user/new-account-pops/interests`,
      {
        interests: interests,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

//get user selected interests
export const getUserInterests = async () => {
  const token = getToken();
  try {
    const response = await axios.get(
      `${apiurl}/api/v1/user/new-account-pops/interests/user`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

// create post
export const createPost = async (data) => {
  const token = getToken();
  try {
    const response = await axios.post(`${apiurl}/api/v1/user/posts`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

//update post
export const updatePost = async (editPostId, formData) => {
  const token = getToken();
  try {
    const response = await axios.post(
      `${apiurl}/api/v1/user/posts/${editPostId}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

//delete post
export const deletePost = async (postId) => {
  const token = getToken();
  try {
    const response = await axios.delete(
      `${apiurl}/api/v1/user/posts/${postId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

//get post by id
export const getPostById = async (postId, uniqueId) => {
  const token = getToken();
  try {
    const response = await axios.get(
      `${apiurl}/api/v1/single-post/${postId}/${uniqueId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    console.log("getPostById response", response);
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};


//report post
export const reportPost = async (postId, data) => {
  const token = getToken();
  try {
    const response = await axios.post(
      `${apiurl}/api/v1/user/posts/${postId}/reports`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

//get all posts
export const fetchAllPosts = async (page, { type, hashtag }) => {
  const token = getToken();
  const params = new URLSearchParams();
  params.append("page", page);

  if (type) {
    params.append("by-type", type);
  } else if (hashtag) {
    params.append("by-hashtag", hashtag);
  }

  const url = `${apiurl}/api/v1/feeds?${params.toString()}`;
  console.log("🌐 FINAL API URL:", url);

  const response = await axios.get(url, {
    headers: { Authorization: `Bearer ${token}` },
  });

  return response.data;
};


//get trending /api/v1/user/hastags/trending
export const getTrending = async () => {
  const token = getToken();
  try {
    const response = await axios.get(`${apiurl}/api/v1/trending`);
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

// get joined group api/v1/user/chats/group-list
export const getJoinedGroups = async () => {
  const token = getToken();
  try {
    const response = await axios.get(`${apiurl}/api/v1/user/chats/group-list`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

//add Reactions to post
export const addReactions = async (postId, reaction) => {
  const token = getToken();
  try {
    const response = await axios.post(
      `${apiurl}/api/v1/user/posts/${postId}/reactions`,
      { reaction },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

//get comments of a post
export const getComments = async (postId, page) => {
  const token = getToken();
  try {
    const response = await axios.get(
      `${apiurl}/api/v1/user/posts/${postId}/comments?page=${page}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

//add comments to a post
export const addComments = async (
  postId,
  inputText,
  mentionedUserIds,
  hashtags
) => {
  console.log("addComments", postId, inputText, mentionedUserIds, hashtags);
  const token = getToken();
  try {
    const response = await axios.post(
      `${apiurl}/api/v1/user/posts/${postId}/comments`,
      {
        comment: inputText,
        tags: mentionedUserIds,
        hashtags: hashtags,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

// update comment
export const updateComment = async (
  postId,
  commentId,
  comment,
  mentionedUserIds,
  hashtag
) => {
  console.log(
    "updateComment",
    postId,
    commentId,
    comment,
    mentionedUserIds,
    hashtag
  );
  const token = getToken();
  try {
    const response = await axios.put(
      `${apiurl}/api/v1/user/posts/${postId}/comments/${commentId}`,
      {
        comment: comment,
        tags: mentionedUserIds,
        hashtags: hashtag,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    console.log("response", response);
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

//add reply to a comment
export const addReply = async (
  postId,
  commentId,
  replyText,
  mentionedUserIds,
  hashtags
) => {
  const token = getToken();
  try {
    const response = await axios.post(
      `${apiurl}/api/v1/user/posts/${postId}/comments/${commentId}/replies`,
      {
        reply: replyText,
        tags: mentionedUserIds,
        hashtags: hashtags,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

// update reply
export const updateReply = async (
  postId,
  commentId,
  replyId,
  reply,
  mentionedUserIds,
  hashtags
) => {
  const token = getToken();
  try {
    const response = await axios.put(
      `${apiurl}/api/v1/user/posts/${postId}/comments/${commentId}/replies/${replyId}`,
      { reply: reply, tags: mentionedUserIds, hashtags: hashtags },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    console.log("response", response);
    return response.data;
  } catch (error) {
    console.log("error", error);
    return Promise.reject(error.response.data);
  }
};

//reactions to a comment
export const addCommentReactions = async (postId, commentId, reaction) => {
  const token = getToken();
  try {
    const response = await axios.post(
      `${apiurl}/api/v1/user/posts/${postId}/comments/${commentId}/reactions`,
      { reaction },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

// reacions to a reply
export const addReplyReactions = async (
  postId,
  commentId,
  replyId,
  reaction
) => {
  const token = getToken();
  try {
    const response = await axios.post(
      `${apiurl}/api/v1/user/posts/${postId}/comments/${commentId}/replies/${replyId}/reactions`,
      { reaction },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

//delete comment
export const deleteComment = async (postId, commentId) => {
  const token = getToken();
  try {
    const response = await axios.delete(
      `${apiurl}/api/v1/user/posts/${postId}/comments/${commentId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

// report comment
export const reportComment = async (postId, commentId, data) => {
  const token = getToken();
  try {
    const response = await axios.post(
      `${apiurl}/api/v1/user/posts/${postId}/comments/${commentId}/reports`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

//delete reply
export const deleteReply = async (postId, commentId, replyId) => {
  const token = getToken();
  try {
    const response = await axios.delete(
      `${apiurl}/api/v1/user/posts/${postId}/comments/${commentId}/replies/${replyId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

//report reply
export const reportReply = async (postId, commentId, replyId, data) => {
  const token = getToken();
  try {
    const response = await axios.post(
      `${apiurl}/api/v1/user/posts/${postId}/comments/${commentId}/replies/${replyId}/reports`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

// get share post count
export const sharePostCount = async (postId) => {
  console.log("sharePostCount", postId);
  try {
    const response = await axios.put(
      `${apiurl}/api/v1/posts/${postId}/shares`,
      {},
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

// get post types
export const getPostTypes = async (query) => {
  const token = getToken();
  try {
    const response = await axios.get(`${apiurl}/api/v1/user/posts/post-types?fetch=${query}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};